import { Box, Button, Modal, Typography } from '@mui/material'
import React from 'react'

const ModalDelete = ({ deleteModal, setDeleteModal, handleDelete, id, label }) => {
    return (
        <Modal
            open={deleteModal}
            onClose={() => setDeleteModal(false)}
            sx={{
                position: "absolute",
                top: "25%",
                width: "450px",
                margin: "auto",
                borderRadius: "20px",
            }}
        >
            <Box
                sx={{
                    mt: 2,
                    bgcolor: "background.paper",
                    borderRadius: 3.6,
                    boxShadow: 24,
                    p: 4.5,
                    "&:focus": {
                        outline: "none",
                    },
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography textAlign={"center"}>Are you sure?</Typography>
                    <Typography textAlign={"center"}>
                        You want to delete this {label}?
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "flex",
                        gap: "25px",
                        width: "max-content",
                        margin: "auto",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        sx={{
                            backgroundColor: "#FF392B",
                            color: "white",
                            border: "",
                            width: "150px",
                            borderRadius: "5px",
                            fontSize: "12px",
                            textTransform: "capitalize",
                            "&:hover": {
                                backgroundColor: "red",
                            },
                        }}
                        onClick={() => handleDelete(id)}
                    >
                        Delete
                    </Button>
                    <Button
                        onClick={() => setDeleteModal(false)}
                        sx={{
                            backgroundColor: "white",
                            color: "black",
                            border: "2px solid #FF392B",
                            width: "150px",
                            borderRadius: "5px",
                            fontSize: "12px",
                            textTransform: "capitalize",
                        }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default ModalDelete;